export const EDICAO_PLANILHA_IMPORTAR = "EDICAO_PLANILHA_IMPORTAR";
export const EDICAO_PLANILHA_EXPORTAR = "EDICAO_PLANILHA_EXPORTAR";
export const EDICAO_PLANILHA_CONFIG = "EDICAO_PLANILHA_CONFIG";
